import { ComponentPropsWithoutRef, forwardRef } from 'react';

import {
  SharedInputProps,
  getInputClassNames,
  FormGroup,
} from '@/components/FormElements';

export interface TextAreaProps
  extends Omit<ComponentPropsWithoutRef<'textarea'>, 'id'>,
    SharedInputProps {}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ displaySize = 'md', invalid, label, id, hideLabel, ...props }, ref) => {
    const inputClasses = getInputClassNames({
      displaySize,
      invalid,
      useDefaultMinHeight: false,
      additional: 'min-h-[12rem] py-2',
    });

    return (
      <FormGroup
        id={id}
        label={label}
        hideLabel={hideLabel}
        required={props.required}
      >
        <textarea id={id} ref={ref} className={inputClasses} {...props} />
      </FormGroup>
    );
  },
);

TextArea.displayName = 'TextArea';
